import React, {useState, useEffect} from 'react';
import { cloneDeep } from 'lodash';

import DropdownWrapper from '../../base/dropdowns/dropdown-wrapper';

import './confirm-dropdown.scss';

const ConfirmDropdown = ({items, updateItems, itemType}) => {
	const itemTypeParts = itemType.split('-');

	const [options, setOptions] = useState(items);

	useEffect(() => setOptions(items), [items]);

	function changeAll(selected) {
		const newOptions = cloneDeep(options);
		newOptions.map((option) => option.selected = selected);
		setOptions(newOptions);
	}

	function selectOption(index) {
		const newOptions = cloneDeep(options);
		newOptions[index].selected = !newOptions[index].selected;
		setOptions(newOptions);
	}

	function getLabel() {
		const selected = items.reduce((acc, option) => {
			return option.selected
				? [...acc, option.label]
				: acc;
		}, []);

		const oneselected = selected.length === 1;
		const allSelected = !selected.length || selected.length === items.length;
		return oneselected ? selected[0] : `${allSelected ? 'All' : selected.length}
			${itemTypeParts[itemTypeParts.length - 1]}`;
	}

	function handleApply() {
		const newOptions = cloneDeep(options);
		if (options.every((option) => !option.selected)) {
			newOptions.map((option) => option.selected = true);
		}
		updateItems(newOptions);
	}

	return (
		<DropdownWrapper label={getLabel()}>
			<div className={`confirm-dropdown ${itemType}`}>
				<div className="change-all-controls" onClick={(e) => e.stopPropagation()}>
					<span className="select-all-btn" onClick={() => changeAll(true)}>Select All</span>
					<span className="pipe">|</span>
					<span className="deselect-all-btn" onClick={() => changeAll(false)}>Deselect All</span>
				</div>

				<div className="options" onClick={(e) => e.stopPropagation()}>
					{options.map((option, index) => (
						<li key={index} className="dropdown-item"
							onClick={() => selectOption(index)}>
							<label>
								<span className={`checkbox ${option.selected ? 'selected' : ''}`}>
								</span>
								{option.label}
							</label>
						</li>
					))}
				</div>

				<div className="confirm-controls">
					<button className="apply-btn" onClick={handleApply}>Apply</button>
					<button>Cancel</button>
				</div>
			</div>
		</DropdownWrapper>
	);
};

export default ConfirmDropdown;
